import { Form, FormInstance, Input } from 'antd';
import SiretInput from 'components/SiretInput';
import { requiredRule, siretRules } from 'const/formRules';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Company } from 'types/Company';
import { NouveauDossierConcessionnaireData } from 'types/Concessionnaire';
import { Option } from 'types/Option';
import { removeSiretSpaces } from 'utils/siret';

interface Props {
  form: FormInstance<NouveauDossierConcessionnaireData>;
}

export default function SiretAndRaisonSociale({ form }: Props) {
  const { t } = useTranslation();

  function onSiretSelect(siret?: Company) {
    if (siret) {
      form.setFieldValue('raisonSociale', siret.name);
      form.setFieldValue('siret', siret.siret);
      form.setFieldValue('accountId', siret.id);
    } else {
      form.setFieldValue('siret', '');
      form.setFieldValue('accountId', null);
    }
  }

  function onSiretSearch(value: string) {
    form.setFieldValue('siret', value);
    form.setFieldValue('accountId', null);
  }

  return (
    <>
      <Form.Item<NouveauDossierConcessionnaireData>
        label={t('nouveau_formulaire:siret:label')}
        name="siret"
        rules={[requiredRule, ...siretRules]}
        getValueFromEvent={(search: string, option: Option) => {
          // Remove all spaces from SIRET input automatically
          const cleanedValue = option?.key ?? search;
          return typeof cleanedValue === 'string'
            ? removeSiretSpaces(cleanedValue)
            : cleanedValue;
        }}
      >
        <SiretInput
          placeholder={t('nouveau_formulaire:siret:placeholder')}
          onSelect={onSiretSelect}
          onSearch={onSiretSearch}
        />
      </Form.Item>

      <Form.Item<NouveauDossierConcessionnaireData>
        label={t('nouveau_formulaire:raison_sociale:label')}
        name="raisonSociale"
        rules={[requiredRule]}
      >
        <Input
          placeholder={t('nouveau_formulaire:raison_sociale:placeholder')}
        />
      </Form.Item>

      <Form.Item<NouveauDossierConcessionnaireData>
        label={t('nouveau_formulaire:etablissement:label')}
        name="etablissement"
        rules={[requiredRule]}
      >
        <Input
          placeholder={t('nouveau_formulaire:etablissement:placeholder')}
        />
      </Form.Item>
    </>
  );
}
